import { SchemaWithClient } from '../types/SchemaWithClient';
import { Client } from '../services/Client';
import { NumberField } from '../components/Table/fields/NumberField';
import { TextField } from '../components/Table/fields/TextField';
import { DateField } from '../components/Table/fields/DateField';
import { SelectField } from '../components/Table/fields/SelectField';
import { enumItems } from './enumItems';
import { SPSelectField } from '../components/Table/fields/SPSelectField';
import { SPNumberField } from '../components/Table/fields/SPNumberField';
import { SPTextField } from '../components/Table/fields/SPTextField';
import { SPDateField } from '../components/Table/fields/SPDateField';
import { BooleanField } from '../components/Table/fields/BooleanField';
import { SPBooleanField } from '../components/Table/fields/SPBooleanField';

export const corporate: SchemaWithClient<any> = {
  name: 'Corporate',
  pluralName: 'Corporate',
  tabs: [
    {
      id: 1,
      label: 'General',
      name: 'general',
    },
  ],
  columns: {
    service_provider: {
      name: 'Service Provider',
      fieldRenderer: SelectField.tableAdapter(enumItems.serviceProvider),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(
        enumItems.serviceProvider
      ),
      url: enumItems.serviceProvider.client.getAllPath,
      tempSchema: enumItems.serviceProvider,
      switchboard: true,
    },
    name: {
      name: 'Legal Name',
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },
    legal_address: {
      name: 'Legal Address',
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },
    tax: {
      name: 'TAX Number',
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },

    payment_conditions: {
      name: 'Invoice & Payment Conditions',
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },

    /* legal_entity: {
      name: 'Legal Entity',
      fieldRenderer: SelectField.tableAdapter(enumItems.legalEntity),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(enumItems.legalEntity),
      url: enumItems.legalEntity.client.getAllPath,
      tempSchema: enumItems.legalEntity,
      switchboard: true,
    },*/
    permanent_contract: {
      name: 'Permanent Contract',
      fieldRenderer: BooleanField,
      slidePaneFieldRenderer: SPBooleanField,
      fieldType: 'boolean',
    },

    valid_contract_until: {
      name: 'Valid Contract Until',
      fieldRenderer: DateField,
      slidePaneFieldRenderer: SPDateField,
      fieldType: 'date',
    },
    id: {
      name: 'ID',
      required: true,
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
      readOnly: true,
    },
  },
  client: new Client('/corporates'),
};
